<template>
    <div
        :class="['offcanvas', offcanvasPosition, isVisible ? 'show' : '']"
        tabindex="-1"
        id="patients-standard-filter"
        aria-modal="true"
        role="dialog"
    >
        <form @submit.prevent>
            <div class="offcanvas-header p-4">
                <h4 class="mb-0">{{ title }}</h4>
                <AppButton
                    btn-class="btn-close"
                    aria-label="Close"
                    @click="close"
                />
            </div>

            <div class="offcanvas-body p-4">
                <slot name="body" />
            </div>

            <div class="offcanvas-footer p-4">
                <div class="row gx-2">
                    <slot name="footer" />
                </div>
            </div>
        </form>
    </div>
    <div
        class="offcanvas-backdrop fade show"
        v-if="props.isVisible"
        @click="close"
    />
</template>

<script setup>
import { defineProps, watch } from "vue";
import AppButton from "@/vue/shared/AppButton.vue";

const props = defineProps({
    title: {
        type: String
    },
    isVisible: {
        type: Boolean,
        default: false
    },
    position: {
        type: String,
        default: "end", // Default to "offcanvas-end"
        validator: (value) => ["start", "end", "top", "bottom"].includes(value)
    },
});

const emits = defineEmits(["update:isVisible"]);
const offcanvasPosition = `offcanvas-${props.position}`;

watch(
    () => props.isVisible,
    (newValue) => {
        emits("update:isVisible", newValue);
    }
);

const close = () => {
    emits("update:isVisible", false);
};
</script>

<style scoped>
.offcanvas-body {
    overflow-y: unset;
}
.offcanvas-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
</style>
